import React from 'react';
import classNames from 'classnames';
import Indicator from './indicator';
import './progress-indicator.scss';

interface IProgressIndicatorProps {
  index: number;
  total: number;
}

const ProgressIndicator: React.SFC<IProgressIndicatorProps> = ({
  index,
  total
}) => {
  return (
    <ul className={classNames('c-progress-indicator')}>
      {Array.from(Array(total).keys()).map(v => (
        <Indicator key={v} active={v === index} />
      ))}
    </ul>
  );
};

export default ProgressIndicator;



// WEBPACK FOOTER //
// ./src/components/progress-indicator/progress-indicator.tsx